import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M12,2A12,12,0,0,0,0,14v2.5A2.5,2.5,0,0,0,2.5,19h19A2.5,2.5,0,0,0,24,16.5V14A12,12,0,0,0,12,2Zm9.5,13.25h-2a.75.75,0,0,1,0-1.5h2a.75.75,0,0,1,0,1.5Zm-2.75-3.82a.73.73,0,0,1-.65-.37.75.75,0,0,1,.27-1L20.1,9a.76.76,0,0,1,1,.28.75.75,0,0,1-.28,1l-1.73,1A.74.74,0,0,1,18.75,11.43Zm-4,2.57A2.75,2.75,0,1,1,12,11.25a2.69,2.69,0,0,1,.81.12l3.74-5.76a.77.77,0,0,1,1-.22.75.75,0,0,1,.22,1l-3.74,5.76A2.77,2.77,0,0,1,14.75,14ZM8.19,8.4a.75.75,0,0,1-1-.27l-1-1.73a.75.75,0,0,1,.27-1,.76.76,0,0,1,1,.28l1,1.73A.75.75,0,0,1,8.19,8.4ZM4.88,11.33l-1.73-1a.75.75,0,0,1-.28-1A.76.76,0,0,1,3.9,9l1.73,1a.75.75,0,0,1-.75,1.3Zm.37,3.17a.76.76,0,0,1-.75.75h-2a.75.75,0,0,1,0-1.5h2A.76.76,0,0,1,5.25,14.5ZM12,3.75a.76.76,0,0,1,.75.75v2a.75.75,0,0,1-1.5,0v-2A.76.76,0,0,1,12,3.75Z",
        fill: "currentColor"
      }),
      _createElementVNode("circle", {
        cx: "12",
        cy: "14",
        r: "1.25",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }